import React from 'react'

const AgAlertsFormula = () => <div>Alerts Formula</div>

export default AgAlertsFormula
